import { createSelector } from '@reduxjs/toolkit'
import type { RootState } from '../store'
import reducer, { ModalState } from './reducer'

export const getModalStore = (state: RootState) =>
  state[reducer.name] as ModalState

export const getModalState = createSelector(getModalStore, (modal) => modal)
export const getModalOpen = createSelector(getModalStore, (modal) => modal.open)
